import React, { FC, createContext } from 'react';
import AntdForm from 'antd/es/form/Form';
import { Store } from 'rc-field-form/lib/interface';
import { TForm } from './From.type';

// Exposes the Form's `initialValues` prop down to FormItem children so they
// can detect whether their field has a pre-populated default value. Used by
// FormItem to hide the required-field asterisk when a default is present.
// Uses Ant Design's own `Store` type so no cast is needed at the provider.
export const FormInitialValuesContext = createContext<Store | undefined>(
  undefined,
);

const Form: FC<TForm> = props => {
  const { layout, initialValues } = props;
  return (
    <FormInitialValuesContext.Provider value={initialValues}>
      <AntdForm layout={layout || 'vertical'} {...props} />
    </FormInitialValuesContext.Provider>
  );
};

export default Form;
